/**
 * Botón toggle de tema (light/dark/system) en el header.
 *
 * Cicla entre 3 estados: light → dark → system → light.
 * Muestra un icono y un label corto.
 */
import { useTheme } from "../hooks/useTheme";

const ICONS: Record<"light" | "dark" | "system", string> = {
  light: "☀️",
  dark: "🌙",
  system: "💻",
};

const LABELS: Record<"light" | "dark" | "system", string> = {
  light: "Claro",
  dark: "Oscuro",
  system: "Sistema",
};

const NEXT_LABEL: Record<"light" | "dark" | "system", string> = {
  light: "Cambiar a Oscuro",
  dark: "Cambiar a Sistema",
  system: "Cambiar a Claro",
};

export default function ThemeToggle() {
  const { mode, cycleMode, effective } = useTheme();

  return (
    <button
      onClick={cycleMode}
      title={NEXT_LABEL[mode]}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-tremor-border bg-white hover:bg-tremor-background-subtle text-tremor-content text-xs font-medium transition-colors"
      aria-label={`Tema actual: ${LABELS[mode]}. Click para cambiar.`}
    >
      <span aria-hidden="true">{ICONS[mode]}</span>
      <span>{LABELS[mode]}</span>
      {mode === "system" && (
        <span className="text-[10px] text-tremor-content opacity-60">
          ({effective === "dark" ? "oscuro" : "claro"})
        </span>
      )}
    </button>
  );
}
